import { CalendarEntry, DateSelectEntry } from './types';

const TICKS_IN_DAY = 1000 * 60 * 60 * 24;

export function generateTwoWeekEntries(startDate: CalendarEntry, available = [], expiration: CalendarEntry): DateSelectEntry[] {
  const startWeekDay = getWeekDay(startDate);

  // todo, see if this can be removed.
  let flag = false;

  const entriesBeforeStart = new Array(startWeekDay).fill(0).map((_, i) => {
    const date: DateSelectEntry = subDays(startDate, startWeekDay - i);

    date.isDisabled = true;

    return date;
  });

  const getUnavailableNum = (available) => {
    const weekDaysMap = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };

    const weekdayNums = Object.values(weekDaysMap);
    const dayNums = available.reduce((prevValue, currValue) => {
      if (weekDaysMap.hasOwnProperty(currValue)) {
        prevValue.push(weekDaysMap[currValue]);
      }
      return prevValue;
    }, []);

    const diff = weekdayNums.filter((num) => !dayNums.includes(num));
    return diff;
  };

  const entriesAfterStart = new Array(13 - startWeekDay).fill(0).map((_, i) => {
    const date: DateSelectEntry = addDays(startDate, i);
    const weekdayNum = new Date(date.year, date.month - 1, date.day).getDay();
    const notOpen = getUnavailableNum(available);

    if (available.length === 0) {
      date.isDisabled = i >= 7;
    }

    if (date.day === expiration.day && date.month === expiration.month && date.year === expiration.year) {
      // enable expiration date in options
      date.isDisabled = false;
      flag = true;
    }

    if (flag) {
      date.isDisabled = true;
    }

    if (available.length !== 0 && notOpen.includes(weekdayNum)) {
      date.isDisabled = true;
    }

    if (date.day === startDate.day && date.month === startDate.month && date.year === startDate.year) {
      date.isStart = true;
    }

    return date;
  });

  return [...entriesBeforeStart, ...entriesAfterStart];
}

export function getCalendarEntry(date: Date): CalendarEntry {
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear(),
  };
}

export function isEntryEqual(entry1: CalendarEntry, entry2: CalendarEntry) {
  return entry1.day === entry2.day && entry1.month === entry2.month && entry1.year === entry2.year;
}

export function expirationPlusOne(expirationDate) {
  const expDate = new Date(expirationDate);
  const tomorrow = expDate;
  tomorrow.setDate(tomorrow.getDate() + 1);

  return {
    day: tomorrow.getDate(),
    month: tomorrow.getMonth() + 1,
    year: tomorrow.getFullYear(),
  };
}

export function currentDatePlusSeven() {
  const d = new Date();

  return new Date(d.setDate(d.getDate() + 7)).toDateString();
}

function subDays(startDate, amount): CalendarEntry {
  return addDays(startDate, -amount);
}

function addDays(startDate, amount): CalendarEntry {
  const { day, month, year } = startDate;
  const date = new Date(year, month - 1, day).getTime() + amount * TICKS_IN_DAY;

  return getCalendarEntry(new Date(date));
}

function getWeekDay(date: CalendarEntry) {
  return new Date(date.year, date.month - 1, date.day).getDay();
}
